import api from '../lib/api';

const adminService = {
    getUsers: async (params = {}) => {
        try {
            const response = await api.get('/admin/users', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    },

    createUser: async (userData) => {
        try {
            const response = await api.post('/admin/users', userData);
            return response.data;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },

    updateUser: async (userId, userData) => {
        try {
            const response = await api.put(`/admin/users/${userId}`, userData);
            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    },

    deleteUser: async (userId) => {
        try {
            const response = await api.delete(`/admin/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting user:', error);
            throw error;
        }
    },

    viewAsUser: async (userId) => {
        try {
            const response = await api.post('/admin/view-as', { user_id: userId });
            return response.data;
        } catch (error) {
            console.error('Error viewing as user:', error);
            throw error;
        }
    },

    approveUser: async (userId) => {
        try {
            const response = await api.post(`/admin/users/${userId}/approve`);
            return response.data;
        } catch (error) {
            console.error('Error approving user:', error);
            throw error;
        }
    },

    rejectUser: async (userId, rejectionData) => {
        try {
            const response = await api.post(`/admin/users/${userId}/reject`, rejectionData);
            return response.data;
        } catch (error) {
            console.error('Error rejecting user:', error);
            throw error;
        }
    },

    getAnalytics: async () => {
        try {
            const response = await api.get('/admin/analytics');
            return response.data;
        } catch (error) {
            console.error('Error fetching admin analytics:', error);
            throw error;
        }
    },

    toggleVerifiedBadge: async (userId) => {
        try {
            const response = await api.post(`/admin/users/${userId}/toggle-verified-badge`);
            return response.data;
        } catch (error) {
            console.error('Error toggling verified badge:', error);
            throw error;
        }
    },

    toggleSellerTrustBadge: async (userId) => {
        try {
            const response = await api.post(`/admin/users/${userId}/toggle-seller-trust-badge`);
            return response.data;
        } catch (error) {
            console.error('Error toggling seller trust badge:', error);
            throw error;
        }
    },

    toggleBuyerProtectionPlus: async (userId) => {
        try {
            const response = await api.post(`/admin/users/${userId}/toggle-buyer-protection-plus`);
            return response.data;
        } catch (error) {
            console.error('Error toggling buyer protection plus:', error);
            throw error;
        }
    }
};

export default adminService; 